import { Component, OnInit, SimpleChanges, OnChanges, Input, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { Hebergement } from 'src/app/entity/hebergement';
import { LogistiqueService } from 'src/app/service/logistique.service'
import { environment } from 'src/environments/environment';
import saveAs from 'save-as'
import { Table } from 'primeng/table';
declare var jsPDF: any;
@Component({
  selector: 'app-hotels',
  templateUrl: './hotels.component.html',
  styleUrls: ['./hotels.component.css']
})
export class HotelsComponent implements OnInit, OnChanges {

  loading: boolean;
  isVisible: boolean;
  ouiNon: SelectItem[];
  ouiNonString: SelectItem[];
  hotelsList: SelectItem[];
  uploadUrl: String = environment.restApiCRM + 'mails/upload1';
  hebergementsObservable: Observable<Hebergement[]>;
  hebergements: Hebergement[];
  selectedHebergement: Hebergement;
  date1: Date;
  @ViewChild('dt' ) DataTableVar: Table;
  date2: Date;
  uploadedFiles: any[] = [];
  file: File;
  cols = [
    { field: 'designation', header: 'Hotel', width: '300px' },
    { field: 'client', header: 'Client', width: '300px' },
    { field: 'nom_prenom', header: 'Nom et prenom', width: '300px' },
    { field: 'date_arrive', header: 'Date Arrivée', width: '300px' },
    { field: 'date_depart', header: 'Date  Départ', width: '300px' },
    { field: 'nbr_nuitee', header: 'Nuitée', width: '300px' },




    { field: 'priseEnCharge', header: 'Prise en charge', width: '300px' },
    { field: 'type_chambre', header: 'Type de chambre', width: '300px' },
    { field: 'transport', header: 'Transport', width: '300px' },
    { field: 'payee', header: 'Payé', width: '300px' },
    { field: 'observation', header: 'Note', width: '300px' },
    { field: 'factureHotel', header: 'Facture Hotel', width: '300px' },
    { field: 'factureClient', header: 'Facture Client', width: '300px' },
  ];

  colsExport = [

    { field: 'client', header: 'Client', width: '300px' },
    { field: 'nom_prenom', header: 'Nom et prenom', width: '300px' },
    { field: 'd1', header: 'Arrivée', width: '300px' },
    { field: 'd2', header: 'Départ', width: '300px' },
    { field: 'nbr_nuitee', header: 'Nuitée', width: '300px' },




    { field: 'priseEnCharge', header: 'Prise en charge', width: '300px' },
    { field: 'type_chambre', header: 'Type de chambre', width: '300px' },
    { field: 'transport', header: 'Transport', width: '300px' },
    { field: 'payeeS', header: 'Payé', width: '300px' },
    { field: 'observation', header: 'Note', width: '300px' },


  ];
  hebergementToJountFile: Hebergement;
  fileType: string;
  types: { label: string; value: string; }[];
  priseEncharges: SelectItem[];
  typeChambres: SelectItem[];
  @Input() index: number;
  exportColumns: { title: string; dataKey: string; }[];

  // [ngStyle]="{'background-color': (selectedHebergement) &&  (rowData.sociFactId === selectedHebergement.sociFactId) ? '#ef8b00' :'white'  }"


  constructor(private logistiqueService: LogistiqueService) { }

  ngOnInit() {


    this.ouiNon = [
      { label: '', value: "" },
      { label: 'Oui', value: true },
      { label: 'Non', value: false },

    ];
    this.ouiNonString = [
      { label: '', value: "" },
      { label: 'Oui', value: 'Oui' },
      { label: 'Non', value: 'Non' },

    ];
    this.types = [
      { label: 'Payé', value: "true" },
      { label: 'Non Payé', value: 'false' },
    ];
    this.priseEncharges = [
      { label: '', value: "" },
      { label: 'Pension Compléte', value: "Pension Compléte" },
      { label: 'Demi Pension', value: 'Demi Pension' },
      { label: 'Chambre Uniquement', value: 'Chambre Uniquement' },
    ];














    this.hotelsList = [
      { label: '', value: "" },
      { label: 'LE MERIDIEN ORAN HOTEL & CONVENTION CENTRE', value: "LE MERIDIEN ORAN HOTEL & CONVENTION CENTRE" },
      { label: 'SHERATON ORAN HOTEL ', value: 'SHERATON ORAN HOTEL ' },
      { label: 'POINTS BY SHERATON ORAN ', value: 'POINTS BY SHERATON ORAN ' },
      { label: 'HOTEL LIBERTE', value: 'HOTEL LIBERTE' },
      { label: 'LES AMBASSADEURS', value: 'LES AMBASSADEURS' },
      { label: 'HOTEL EL MOUAHIDINE', value: 'HOTEL EL MOUAHIDINE' },
      { label: 'EDEN AIRPORT ORAN', value: 'EDEN AIRPORT ORAN' },
      { label: 'HOTEL EDEN PHOENIX', value: 'HOTEL EDEN PHOENIX' },
      { label: 'LE PACHA HOTEL', value: 'LE PACHA HOTEL' },
      { label: 'RODINA HÔTEL, SPA & CONFÉRENCES', value: 'RODINA HÔTEL, SPA & CONFÉRENCES' },
      { label: 'HOTEL MAGHREB EL ARABI BELGAID', value: 'HOTEL MAGHREB EL ARABI BELGAID' },
      { label: 'LE ZENITH HOTEL ', value: 'LE ZENITH HOTEL ' },
      { label: 'HOTEL ADEF', value: 'HOTEL ADEF' },
      { label: "HOTEL PORTE D'ORAN", value: "HOTEL PORTE D'ORAN" },
      { label: 'SOFI HOTEL', value: 'SOFI HOTEL' },
      { label: 'BEST WESTERN COLOMBE HOTEL ORAN', value: 'BEST WESTERN COLOMBE HOTEL ORAN' },
      { label: 'HOTEL LIBERTE EXPRESS', value: 'HOTEL LIBERTE EXPRESS' },
      { label: 'RÉSIDENCE LE JASMINS', value: 'RÉSIDENCE LE JASMINS' },
      { label: 'LE ROYAL HOTEL ORAN - MGALLERY BY SOFITEL', value: 'LE ROYAL HOTEL ORAN - MGALLERY BY SOFITEL' },
      { label: 'HOTEL VENDOME KHALED ORAN', value: 'HOTEL VENDOME KHALED ORAN' },

    ];




    this.typeChambres = [
      { label: '', value: "" },
      { label: 'Suite', value: "Suite" },
      { label: 'Standard', value: 'Standard' },
      { label: 'Double', value: 'Double' },
      { label: 'Appartement', value: 'Appartement' },
    ];
    this.exportColumns = this.colsExport.map(col => ({ title: col.header, dataKey: col.field }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.index == 4 && !this.hebergementsObservable) {
      this.findAll()
    }

  }

  prepareHebergement() {
    this.selectedHebergement = new Hebergement()
    this.selectedHebergement.date_arrive = new Date();
    this.selectedHebergement.date_depart = new Date();
    this.isVisible = true;
  }
  dateArrivee:Date;
  dateDepart:Date;
  prepareEditHebergement() {
this.dateArrivee=new Date(this.selectedHebergement.date_arrive);
this.dateDepart=new Date(this.selectedHebergement.date_depart);

    this.isVisible = true;
  }
  selectUpload(rowData: Hebergement, type: string) {
    //console.log("selecte upload");

    this.hebergementToJountFile = rowData;
    this.fileType = type;
  }
  uploadFunction(event) {
    this.uploadedFiles = [];
    for (let file of event.files) {


      this.uploadedFiles.push(file);

    }
    this.saveFile(this.fileType);
  }
  showFile(hebergement: Hebergement, type: string) {
    //console.log('resultresul');

    this.logistiqueService.showFile(hebergement, type).subscribe(result => {



      saveAs(result, result.name)
    });
  }
  saveFile(type: string) {
    let fd = new FormData();
    let fileName = this.hebergementToJountFile.id_hebergement + "_" + type;
    for (let file of this.uploadedFiles) {


      fd.append("file", file, fileName);


    }
    this.logistiqueService.uploadFile(fd, fileName + ".pdf", this.hebergementToJountFile.id_hebergement).subscribe(result => {
      this.findAll()
      //   this.findAllPjoints();
    });
  }


  saveHebergement() {
    //console.log('this.selectedHebergement' + this.selectedHebergement.date_arrive);

this.selectedHebergement.date_arrive=this.dateArrivee;
this.selectedHebergement.date_depart=this.dateDepart;
    if (this.selectedHebergement.id_hebergement)
      this.logistiqueService.editHebergement(this.selectedHebergement).subscribe(result => {
        this.findAll()
      })
    else
      this.logistiqueService.addHebergement(this.selectedHebergement).subscribe(result => {
        this.findAll()
      })
  }
  findAll() {
    this.hebergements = []
    this.hebergementsObservable = this.logistiqueService.getAllHebergements();
    this.hebergementsObservable.subscribe(result => {


      result.forEach(element => {
        let d1: Date = new Date(element.date_depart);
        let d2: Date = new Date(element.date_arrive);

        //console.log("de de2" + d2);
        
        var options = {timeZone: "UTC", timeZoneName: "short"};
         element.d1 = d1.toLocaleDateString("nl",{year:"2-digit",month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit"})  ;
       element.d2 = d2.toLocaleDateString("nl",{year:"2-digit",month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit"})  ;
        element.payeeS = element.payee ? 'OUI' : 'NON';
        this.hebergements.push(element)



      });

    })

    this.isVisible = false;
  }
  removeHebergement() {
    this.logistiqueService.removeHebergement(this.selectedHebergement).subscribe(result => {
      this.findAll()
    })
  }



  exportPdf() {
    let hebergementsL: Hebergement[] = [];

    var doc = new jsPDF('l');
    doc.setFontSize(18);
    if (this.DataTableVar.filteredValue)
      doc.text(this.DataTableVar.filteredValue[0].designation, 120, 10);
    else doc.text('', 120, 10);
    //	doc.text(document.getElementById("rptname").value, 220, 50);
    doc.setFontSize(8);
    doc.setTextColor(100);


    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue) {

      hebergementsL = this.DataTableVar.filteredValue;

      this.DataTableVar.filteredValue = [];
      hebergementsL.forEach(element => {
        let d1: Date = new Date(element.date_depart);
        let d2: Date = new Date(element.date_arrive);

        //console.log("de de2" + d2);

 
        element.d1 = d1.toLocaleDateString("nl",{year:"2-digit",month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit"})  ;
        element.d2 = d2.toLocaleDateString("nl",{year:"2-digit",month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit"})  ;
        element.payeeS = element.payee ? 'OUI' : 'NON';
        this.DataTableVar.filteredValue.push(element)
        doc.autoTable(

          this.exportColumns, this.DataTableVar.filteredValue, {


          margin: { vertical: 17, horizontale: 17 },

          columnStyles: {
            0: { columnWidth: 30 }, 1: { columnWidth: 40 }, 2: { columnWidth: 25 }
            , 3: { columnWidth: 25 }, 4: { columnWidth: 15 }, 9: { columnWidth: 25 }
          }
        });


      });
    }

    else doc.autoTable(
      this.exportColumns, this.hebergements, {


      margin: { vertical: 17, horizontale: 17 },

      columnStyles: {
        0: { columnWidth: 30 }, 1: { columnWidth: 40 }, 2: { columnWidth: 25 }
        , 3: { columnWidth: 25 }, 4: { columnWidth: 15 }, 9: { columnWidth: 25 }
      }
    });

    doc.save('Liste des hotels.pdf');


  }

  calculeNuitee() {
    if (this.selectedHebergement.date_depart && this.selectedHebergement.date_arrive)
      this.selectedHebergement.nbr_nuitee = this.calculateDiff(this.selectedHebergement.date_arrive, this.selectedHebergement.date_depart)
  }
  calculateDiff(date1: Date, date2: Date): number {



    return Math.floor((Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) - Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())) / (1000 * 60 * 60 * 24));
  }

}
